<button
  (click)="buttonClick.emit($event)"
  class="bg-primary-600 text-white text-sm icon icon-plus rounded-full h-7.5 w-7.5"
></button>
